<template>
  <a-row>
    <a-col :span="labelCol" v-if="title">
      <div class="label-title">{{ title }}</div>
    </a-col>
    <a-col :span="valueCol">
      <a-form-item v-bind="validate">
        <QuillEditor ref="quillEditor" :content="inputValue" @change="onChange" />
        <span v-if="validate" class="must">*</span>
      </a-form-item>
    </a-col>
  </a-row>
</template>

<script>
import { defineComponent, ref, watch } from 'vue'
import QuillEditor from '@/components/editor/QuillEditor.vue'

export default defineComponent({
  props: {
    value: {
      type: String
    },

    title: {
      type: String,
      default: '标题'
    },

    labelCol: {
      type: Number,
      default: 4
    },

    valueCol: {
      type: Number,
      default: 16
    },

    validate: {
      type: Object,
      default: () => null
    },

    disabled: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      default: 'text'
    }
  },
  components: {
    QuillEditor
  },
  emits: ['ok', 'update:value'],
  setup (props, { emit }) {
    const inputValue = ref('')

    watch(() => props.value, e => {
      inputValue.value = e
    })

    const onChange = e => {
      emit('ok', e)
      emit('update:value', e)
    }

    return {
      inputValue,
      onChange
    }
  }
})
</script>

<style lang="less" scoped>
.must {
  position: absolute;
  top: 3px;
  right: -10px;
  color: #f00;
  font-size: 18px;
  line-height: 32px;
}
</style>
